import platform from 'utils/platform';
import { getCurrentPosition, getLocationPermission } from 'utils/events';
import { LOCATION_OPTIONS } from 'constants/digitalLoan';

export const POSTAL_CODE_LENGTH = 5;

export function formatPostalCode(value = '') {
  let digits = String(value).replace(/\D/g, '');
  if (digits.length > POSTAL_CODE_LENGTH) {
    digits = digits.slice(0, POSTAL_CODE_LENGTH);
  }
  return digits;
}

export function isValidPostalCode(postalCode = '') {
  return /^\d{5}$/.test(postalCode);
}

export function isValidCoordinateValue(value) {
  return typeof value === 'number' && Number.isFinite(value);
}

export function isValidCoordinates(latitude, longitude) {
  return (
    isValidCoordinateValue(latitude)
    && isValidCoordinateValue(longitude)
    && latitude >= -90
    && latitude <= 90
    && longitude >= -180
    && longitude <= 180
  );
}

export async function acquireCurrentCoordinates() {
  const granted = await getLocationPermission();
  if (!granted) {
    return { error: 'permission_denied' };
  }

  if (platform.isNativeApp) {
    const position = await getCurrentPosition();
    const { latitude, longitude } = position || {};
    if (!isValidCoordinates(latitude, longitude)) {
      return { error: 'unavailable' };
    }
    return { latitude, longitude };
  }

  if (!navigator.geolocation) {
    return { error: 'unsupported' };
  }

  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        if (!isValidCoordinates(latitude, longitude)) {
          resolve({ error: 'unavailable' });
          return;
        }
        resolve({ latitude, longitude });
      },
      () => resolve({ error: 'unavailable' }),
      { timeout: 10000, maximumAge: 0 },
    );
  });
}

/** Solo NEGOCIO_CERCA exige nombre de negocio. */
export function requiresCompanyOrBusinessName(locationType) {
  return locationType === LOCATION_OPTIONS.BUSINESS_NEARBY;
}

/** Solo VIVO_CERCA exige comprobante de domicilio. */
export function requiresProofOfAddress(locationType) {
  return locationType === LOCATION_OPTIONS.LIVE_NEARBY;
}

export function canEnableValidate({
  locationOption,
  postalCode,
  locationAuthorized,
  coordinates,
  companyOrBusinessName = '',
  isSubmitting,
  isAcquiringLocation = false,
}) {
  const companyRequired = requiresCompanyOrBusinessName(locationOption);
  const companyOk = !companyRequired || !!companyOrBusinessName?.trim();

  return (
    !!locationOption
    && companyOk
    && isValidPostalCode(postalCode)
    && locationAuthorized
    && isValidCoordinates(coordinates?.latitude, coordinates?.longitude)
    && !isSubmitting
    && !isAcquiringLocation
  );
}
